import { getSubscription } from '@modusign/openapi-client-subscription';
import { all, delay, put, retry, takeLatest } from 'redux-saga/effects';

import { REPLICATION_DELAY } from '@app/constants/delayTime';
import { payInvoice, updatePrimaryPaymentMethodSuccess } from '@app/features/payment';
import {
  fetchSubscriptionDataFailure,
  fetchSubscriptionDataSuccess,
} from '@app/features/subscription/state';
import SubscriptionStatus from '@app/features/subscription/types/SubscriptionStatus';
import workspaceService from '@app/libs/workspaceService';
import {
  SUBSCRIPTION_DATA_FETCH_REQUEST,
  SUBSCRIPTION_TRIAL_PLAN_START_SUCCESS,
  SUBSCRIPTION_TRIAL_PLAN_START_WITH_SURVEY_SUCCESS,
} from '@app/store/actionTypes';
import { GetSubscriptionResponse } from '@app/store/transport-layer/subscription/subscription';

export function convertDomainSubscription(data: GetSubscriptionResponse) {
  return data
    ? {
        createdAt: data.createdAt,
        currentTimes: data.currentTimes,
        id: data.id,
        isSubscribing: data.isSubscribing,
        maxTimes: data.maxTimes === -1 ? Infinity : data.maxTimes,
        nextInvoicingDate: data.nextInvoicingDate,
        nextPlan: data.nextPlan && {
          defaultSeat: data.nextPlan.defaultSeat,
          grade: data.nextPlan.grade,
          id: data.nextPlan.id,
          interval: data.nextPlan.resetPeriod.value * data.nextPlan.suppliedResetCount,
          price: data.nextPlan.price,
          resetPeriod: data.nextPlan.resetPeriod,
          seatUnitPrice: data.nextPlan.seatUnitPrice,
          suppliedResetCount: data.nextPlan.suppliedResetCount,
          title: data.nextPlan.title,
        },
        nextResetDate: data.nextResetDate,
        plan: data.plan && {
          applicationId: data.plan.applicationId,
          defaultSeat: data.plan.defaultSeat,
          grade: data.plan.grade,
          id: data.plan.id,
          interval: data.plan.resetPeriod.value * data.plan.suppliedResetCount,
          price: data.plan.price,
          resetPeriod: data.plan.resetPeriod,
          seatUnitPrice: data.plan.seatUnitPrice,
          suppliedResetCount: data.plan.suppliedResetCount,
          title: data.plan.title,
        },
        remainingResetCount: data.remainingResetCount,
        resetDateOfMonth: data.resetDateOfMonth,
        seat: data.seat,
        status: SubscriptionStatus[data.status],
        updatedAt: data.updatedAt,
        userId: data.userId,
      }
    : null;
}

export function* fetchSubscriptionData({ type }: { type: string }) {
  try {
    if (type !== SUBSCRIPTION_DATA_FETCH_REQUEST) {
      yield delay(REPLICATION_DELAY);
    }
    const result: GetSubscriptionResponse = yield retry(
      3,
      2 * 1000,
      getSubscription,
      workspaceService.getWorkspaceId()
    );

    yield put(fetchSubscriptionDataSuccess(convertDomainSubscription(result)));
  } catch (error) {
    yield put(fetchSubscriptionDataFailure(error));
  }
}

export default function* sagas() {
  yield all([
    takeLatest(
      [
        SUBSCRIPTION_DATA_FETCH_REQUEST,
        SUBSCRIPTION_TRIAL_PLAN_START_SUCCESS,
        SUBSCRIPTION_TRIAL_PLAN_START_WITH_SURVEY_SUCCESS,
        updatePrimaryPaymentMethodSuccess.type,
        payInvoice.fulfilled.type,
      ],
      fetchSubscriptionData
    ),
  ]);
}
